import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  Container,
  Dropdown,
  Nav,
  Navbar,
  Image,
  Offcanvas,
  Modal,
  Form,
  Button,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import AuthService from "../../services/auth.service";
import UserService from "../../services/user.service";
import Logo from "../../assets/images/logo.svg";
import Avatar from "../../assets/images/avatar.svg";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import { eventBus } from "./EventBus";

const NavBar = (props) => {
  let { uuid } = useParams();
  var splitUrl = window.location.href.split("/");
  const [parentUserUUId, setParentUserUUId] = useState("");

  useEffect(() => {
    const parentUserUUId = localStorage.getItem("parentUser.uuid");

    setParentUserUUId(parentUserUUId);
  }, [splitUrl, uuid]); // Runs when the URL changes

  var navbarClass = props.isOpen ? "open pb-0" : "pb-0";
  let history = useHistory();
  const [showFamilyNav, setShowFamilyNav] = useState(false);
  let userType = localStorage.getItem("userType");
  const [familyName, setFamilyName] = useState("");
  const [familyDetails, setFamilyDetails] = useState({
    FamilyId: "",
    UserId: "",
    createdAt: "",
    id: "",
    inviteStatus: "",
    invitedBy: "",
    isAo: "",
    isAu: userType ? userType.includes("AU") : false,
    isSu: true,
    settings1: "",
    settings2: "",
    settings3: "",
    status: "",
    updatedAt: "",
  });

  const isFamilyDashboardActive = window.location.href.includes("/dashboard");
  const isSupportingDashboardActive = window.location.href.includes(
    "/supporting_user_dashboard"
  );
  const [isSubsActive, setIsSubsActive] = useState("");
  const [isTasksActive, setIsTasksActive] = useState("");
  const [isBenefitsActive, setIsBenefitsActive] = useState("");
  const [isGiftCardsActive, setIsGiftCardsActive] = useState("");
  const [isWarrantyActive, setIsWarrantyActive] = useState("");
  const [isCompareActive, setIsCompareActive] = useState("");
  const [isSavingsActive, setIsSavingsActive] = useState("");
  const [familyLoadError, setFamilyLoadError] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [familyLengthVal, setfamilyLengthVal] = useState([]);

  let items = localStorage.getItem("UserDetails");
  let uuidDetails = localStorage.getItem("uuid");
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));

  const initialFmlyNameValues = {
    family_name: "",
  };
  const [updateFmlyFormValues, setUpdateFmlyFormValues] = useState(
    initialFmlyNameValues
  );

  const handleUpdateFmlyChange = (e) => {
    const { name, value } = e.target;
    setUpdateFmlyFormValues({ ...updateFmlyFormValues, [name]: value });
  };

  const handleeventlog = () => {
    history.push(uuidDetails ? `/family_notification/${splitUrl[4]}` : "#");
  };

  const handleRemSetting = () => {
    history.push(uuidDetails ? `/group_settings/${splitUrl[4]}` : "#");
  };

  const handleSwitchGroup = () => {
    history.push("/family_selection");
  };

  const handleInvites = () => {
    if (splitUrl[4]) {
      history.push(`/myInvites/${splitUrl[4]}`);
    } else {
      history.push(`/myInvites`);
    }
  };

  const handleLogout = () => {
    AuthService.logout();
    history.push("/");
  };

  const handleChangePlan = () => {
    if (splitUrl[4]) {
      history.push(`/manageSubscription/${splitUrl[4]}`);
    } else {
      history.push(`/manageSubscription/${uuidDetails}`);
    }
  };

  useEffect(() => {
    if (!UserDetails) {
      return;
    }

    UserService.getUserAccountPlan(UserDetails.uuid).then((resp) => {
      let newData = [];
      if (resp && Array.isArray(resp.usersFamilyData)) {
        for (let i = 0; i < resp.usersFamilyData.length; i++) {
          if (
            resp.usersFamilyData[i] &&
            resp.usersFamilyData[i].Family &&
            resp.usersFamilyData[i].Family.status !== "InActive"
          ) {
            newData.push(resp.usersFamilyData[i]);
          }
        }
      }
      setfamilyLengthVal(newData);
    });
    if (splitUrl[4]) {
      UserService.getUserSingleFamilyDetails(splitUrl[4], UserDetails.id).then(
        (response) => {
          const initialFmlyNameValues = {
            family_name:
              response && response.FamilyData && response.FamilyData.Family
                ? response.FamilyData.Family.name
                : "",
          };
          setUpdateFmlyFormValues(initialFmlyNameValues);
        }
      );
    }
  }, []);

  // Redirecting during render does not stop the render, so the component used
  // to fall straight through into the dereferences below and throw. Bail out of
  // the render and let the effect do the navigating.
  useEffect(() => {
    if (!items) {
      history.push("/");
    }
  }, [items]);

  useEffect(() => {
    setShowFamilyNav(false);

    if (uuid) {
      if (uuid.includes("elf-")) {
        if (
          splitUrl[3] === "support_dashboard" ||
          splitUrl[3] === "newcard_billing_details"
        ) {
          setShowFamilyNav(false);
        } else {
          setShowFamilyNav(true);
        }

        // get family details
        if (UserDetails) {
          UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
            (response) => {
              // An auth failure has already torn the session down and is
              // navigating to the login page - do not race it.
              if (response && response.isAuthError) {
                return;
              }

              // Only a definite "this group does not exist / you are not in it"
              // answer justifies sending the user away. Anything carrying an
              // HTTP error status is a transient failure, and bouncing to /404
              // on those is what stranded users on a dead-end page.
              const isTransientFailure =
                !response || (response.status && response.status >= 400);

              if (isTransientFailure) {
                setFamilyLoadError(true);
                return;
              }

              if (
                response.message === "Family not Found !" ||
                !response.FamilyData ||
                !response.FamilyData.Family
              ) {
                history.push("/404");
                return;
              }

              setFamilyLoadError(false);
              setFamilyDetails(response.FamilyData);
              setFamilyName(response.FamilyData.Family.name);
            },
            () => {
              setFamilyLoadError(true);
            }
          );
        }
      }
    }

    if (
      window.location.href.indexOf("warranties") > -1 ||
      window.location.href.indexOf("warranty") > -1
    ) {
      setIsWarrantyActive("warranties");
    }

    if (window.location.href.indexOf("discounts") > -1) {
      setIsBenefitsActive("discounts");
    }

    if (window.location.href.indexOf("compare_and_save") > -1) {
      setIsCompareActive("CompareAndSave");
    }

    if (
      window.location.href.indexOf("myoutgoings") > -1 ||
      window.location.href.indexOf("outgoing") > -1
    ) {
      setIsSubsActive("myoutgoings");
    }

    // Gift cards
    if (window.location.href.indexOf("gift_cards") > -1) {
      setIsGiftCardsActive("GiftCards");
    }

    // Task
    if (window.location.href.indexOf("todos") > -1) {
      setIsTasksActive("To-do");
    }

    if (window.location.href.indexOf("savings") > -1) {
      setIsSavingsActive("Savings");
    }
  }, [uuid]);

  let userDetails = JSON.parse(localStorage.getItem("UserDetails"));

  const noImgError = (e) => {
    e.target.setAttribute("src", Avatar);
  };

  const [shown, setshown] = useState(false);
  const [shown1, setshown1] = useState(false);
  const [shown2, setshown2] = useState(false);
  const [shown3, setshown3] = useState(false);
  const [shown4, setshown4] = useState(false);
  const [shown5, setshown5] = useState(false);

  const handleSubscription = () => {
    history.push(`/newcard_billing_details`);
  };

  const handleProfile = () => {
    if (splitUrl[4]) {
      history.push(`/profile/${splitUrl[4]}`);
    } else {
      history.push(`/profile`);
    }
  };

  const [showUpdateFmlyModal, setShowUpdateFmlyModal] = useState(false);
  const [updateFmlyFormErrors, setUpdateFmlyFormErrors] = useState("");
  const [isUpdateFmlySubmit, setIsUpdateFmlySubmit] = useState(false);

  const handleChangeGroupName = () => {
    setShowUpdateFmlyModal(!showUpdateFmlyModal);
  };

  useEffect(() => {
    eventBus.on("triggerGroupNameChange", handleChangeGroupName);
    return () => {
      eventBus.off("triggerGroupNameChange", handleChangeGroupName);
    };
  }, []);

  const handleFamilyNameSubmit = (e) => {
    e.preventDefault();
    setUpdateFmlyFormErrors(validateFamilyName(updateFmlyFormValues));
    setIsUpdateFmlySubmit(true);
  };

  const validateFamilyName = (values) => {
    const errors = {};
    if (!values.family_name) {
      errors.msg = "Please enter group name";
      errors.family_name = "Yes";
    }
    return errors;
  };

  useEffect(() => {
    if (Object.keys(updateFmlyFormErrors).length === 0 && isUpdateFmlySubmit) {
      // setFormLoading(true);
      let data = {
        name: updateFmlyFormValues.family_name,
      };

      const urlData = uuid ? uuid : uuidDetails;
      // api call
      UserService.updateFamilyName(urlData, data).then(
        (res) => {
          if (res.status === 400) {
            // setFormLoading(false);
            setShowUpdateFmlyModal(false);
            setSuccessToast(false);
            setShowToast(true);
            setToastMessage(res.data.message);
          } else {
            // setFormLoading(false);
            setShowUpdateFmlyModal(false);
            window.scrollTo(0, 0);
            setSuccessToast(true);
            setShowToast(true);
            setToastMessage("Group Name have been successfully updated");
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }
        },
        (error) => {
          // setFormLoading(false);
        }
      );
    }
  }, [updateFmlyFormErrors]);

  useEffect(() => {
    if (familyLengthVal.length > 0) {
      if (userType) {
        if (
          userType === "AO + AU" ||
          userType === "AO + AU + SU" ||
          userType === "AO" ||
          userType === "AO + SU"
        ) {
          setshown(true);
          setshown1(false);
          setshown2(false);
          setshown3(false);
          setshown4(false);
          setshown5(false);
        } else {
          setshown1(true);
          setshown(false);
          setshown2(false);
          setshown3(false);
          setshown4(false);
          setshown5(false);
        }
      } else {
        if (splitUrl[3] === "family_selection") {
          setshown(false);
          setshown1(false);
          setshown2(true);
          setshown3(false);
          setshown4(false);
          setshown5(false);
        } else if (splitUrl[3] === "subscription") {
          setshown(false);
          setshown1(false);
          setshown2(false);
          setshown3(true);
          setshown4(false);
          setshown5(false);
        } else {
          setshown(false);
          setshown1(false);
          setshown2(true);
          setshown3(false);
          setshown4(false);
          setshown5(false);
        }
      }
    } else {
      if (
        splitUrl[3] === "subscription" ||
        splitUrl[3] === "newcard_billing_details"
      ) {
        setshown(false);
        setshown1(false);
        setshown2(false);
        setshown3(false);
        setshown4(true);
        setshown5(false);
      }
      if (splitUrl[3] === "myInvites") {
        setshown(false);
        setshown1(false);
        setshown2(false);
        setshown3(false);
        setshown4(false);
        setshown5(true);
      }
    }
  }, [familyLengthVal.length, splitUrl, userType]);

  // No session: render nothing and let the effect above navigate to login.
  // Falling through would dereference userDetails and blank the whole app.
  if (!userDetails) {
    return null;
  }

  const hasName =
    userDetails.firstname &&
    userDetails.firstname !== "null" &&
    userDetails.lastname &&
    userDetails.lastname !== "null";
  const displayName = hasName
    ? `${userDetails.firstname} ${userDetails.lastname}`
    : userDetails.email || "";

  if (splitUrl[3] !== "confirmation" && splitUrl[3] !== "onboardUser") {
    return (
      <>
        <Navbar className={navbarClass} collapseOnSelect expand="xl">
          <ToastBlockContainer
            successToast={successToast}
            showToast={showToast}
            setShowToast={setShowToast}
            toastMessage={toastMessage}
          />
          {familyLoadError && (
            <div className="alert alert-warning d-flex align-items-center justify-content-between w-100 mb-0">
              <span>
                We couldn't load this group just now. Your data is safe.
              </span>
              <Button
                variant="outline-dark"
                size="sm"
                onClick={() => window.location.reload()}
              >
                Retry
              </Button>
            </div>
          )}
          <Container fluid className="mb-5">
            {splitUrl[3] !== "family_selection" &&
            splitUrl[4] !== undefined &&
            splitUrl[4] !== "not-found" ? (
              <>
                {splitUrl[3] === "support_dashboard" ? (
                  <Link
                    className={`navbar-brand order-xl-first ${
                      splitUrl[3] === "newcard_billing_details" &&
                      splitUrl[3] === "signup" &&
                      "z-index-99999"
                    }`}
                    to={`/family_selection`}
                  >
                    <img src={Logo} alt="logo" />
                  </Link>
                ) : (
                  <>
                    {!parentUserUUId ? (
                      <Link
                        className={`navbar-brand order-xl-first ${
                          splitUrl[3] === "newcard_billing_details" &&
                          splitUrl[3] === "signup" &&
                          "z-index-99999"
                        }`}
                        to={
                          splitUrl[4] === "new-user"
                            ? `/family_selection`
                            : `/dashboard/${splitUrl[4]}`
                        }
                      >
                        <img src={Logo} alt="logo" />
                      </Link>
                    ) : (
                      <Link
                        className={`navbar-brand order-xl-first ${
                          splitUrl[3] === "newcard_billing_details" &&
                          "z-index-99999"
                        }`}
                        to={
                          splitUrl[4] === "new-user"
                            ? `/family_selection`
                            : `/supporting_user_dashboard/${splitUrl[4]}/${
                                parentUserUUId !== "undefined"
                                  ? parentUserUUId
                                  : splitUrl[5]
                              }`
                        }
                      >
                        <img src={Logo} alt="logo" />
                      </Link>
                    )}
                  </>
                )}
              </>
            ) : (
              <Link
                className={`order-xl-first a1 ${
                  splitUrl[3] === "newcard_billing_details" && "z-index-99999"
                }`}
                to={`/family_selection`}
              >
                <img src={Logo} alt="logo" />
              </Link>
            )}
            {showFamilyNav && (
              <Navbar.Toggle
                className="order-last ms-2 ms-md-3 ms-xl-0"
                aria-controls="navbar-nav"
              />
            )}

            <div className="navbar-new-header" style={{ fontSize: "14px" }}>
              <Nav className="align-items-xl-center flex-grow-1">
                {showFamilyNav && (
                  <>
                    {(userType === "AO + AU + SU" ||
                      userType === "AO + AU" ||
                      userType === "AU + SU" ||
                      userType === "AU" ||
                      parentUserUUId) && (
                      <>
                        <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isFamilyDashboardActive ||
                              isSupportingDashboardActive
                                ? "active"
                                : ""
                            }`}
                            to={
                              !parentUserUUId
                                ? `/dashboard/${splitUrl[4]}`
                                : `/supporting_user_dashboard/${splitUrl[4]}/${
                                    parentUserUUId !== "undefined"
                                      ? parentUserUUId
                                      : splitUrl[5]
                                  }`
                            }
                          >
                            Dashboard
                          </Link>
                        </div>
                        <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isSubsActive ? "active" : ""
                            }`}
                            to={
                              !parentUserUUId
                                ? `/myoutgoings/${splitUrl[4]}`
                                : `/user_myoutgoings/${splitUrl[4]}/${
                                    parentUserUUId !== "undefined"
                                      ? parentUserUUId
                                      : splitUrl[5]
                                  }`
                            }
                          >
                            Outgoings
                          </Link>
                        </div>
                        <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isWarrantyActive ? "active" : ""
                            }`}
                            to={
                              !parentUserUUId
                                ? `/warranties/${splitUrl[4]}`
                                : `/user_warranties/${splitUrl[4]}/${
                                    parentUserUUId !== "undefined"
                                      ? parentUserUUId
                                      : splitUrl[5]
                                  }`
                            }
                          >
                            Warranties
                          </Link>
                        </div>
                        <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isGiftCardsActive ? "active" : ""
                            }`}
                            to={
                              !parentUserUUId
                                ? `/vouchers_&_gift_cards/${splitUrl[4]}`
                                : `/user_vouchers_&_gift_cards/${splitUrl[4]}/${
                                    parentUserUUId !== "undefined"
                                      ? parentUserUUId
                                      : splitUrl[5]
                                  }`
                            }
                          >
                            Vouchers & Gift cards
                          </Link>
                        </div>
                        <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isTasksActive ? "active" : ""
                            }`}
                            to={
                              !parentUserUUId
                                ? `/todos/${splitUrl[4]}`
                                : `/user_todos/${splitUrl[4]}/${
                                    parentUserUUId !== "undefined"
                                      ? parentUserUUId
                                      : splitUrl[5]
                                  }`
                            }
                          >
                            To-Dos
                          </Link>
                        </div>
                        <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isSavingsActive ? "active" : ""
                            }`}
                            to={
                              !parentUserUUId
                                ? `/savings/${splitUrl[4]}`
                                : `/user_savings/${splitUrl[4]}/${
                                    parentUserUUId !== "undefined"
                                      ? parentUserUUId
                                      : splitUrl[5]
                                  }`
                            }
                          >
                            Life Accounts
                          </Link>
                        </div>
                        {/* <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isBenefitsActive ? "active" : ""
                            }`}
                            to={`/discounts/${splitUrl[4]}`}
                          >
                            Discounts
                          </Link>
                        </div> */}
                        <div className="nav-item">
                          <Link
                            className={`nav-link ${
                              isCompareActive ? "active" : ""
                            }`}
                            to={`/compare_and_save/${splitUrl[4]}`}
                          >
                            Compare & save
                          </Link>
                        </div>
                      </>
                    )}
                  </>
                )}
              </Nav>
            </div>

            <Dropdown
              className={`ms-auto  ${
                splitUrl[3] === "newcard_billing_details" && "z-index-99999"
              }`}
            >
              <Dropdown.Toggle
                className="navbar-dropdown-toggle p-0 d-flex align-items-center navbar-username"
                variant="Warning"
                id="dropdown-basic"
              >
                <div class="overflow-hidden text-end">
                  <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id="button-tooltip" {...props}>
                        {displayName}
                      </Tooltip>
                    }
                  >
                    <div className="fw-bold text-dark text-truncate mb-0">
                      {displayName}
                    </div>
                  </OverlayTrigger>
                  {/* <div className="small fw-medium text-bod-secondary lh-sm text-truncate mb-0">
                    {userType === "AO"
                      ? "Admin"
                      : userType === "AO + AU"
                      ? "Admin + Main user"
                      : userType === "AO + SU"
                      ? "Admin + Support user"
                      : userType === "AO + AU + SU"
                      ? "Admin + Main + Support user"
                      : userType === "AU"
                      ? "Main user"
                      : userType === "AU + SU"
                      ? "Main + Support user"
                      : userType === "SU"
                      ? "Support user"
                      : ""}
                  </div> */}
                </div>
                <div className="avatar flex-shrink-0 ms-3 ms-md-4">
                  <Image
                    className=""
                    src={userDetails.avatar || Avatar}
                    onError={noImgError}
                    alt="Profile Avatar"
                    id="dropdown-basic"
                  />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-end right-top-div">
                {shown && (
                  <>
                    {familyLengthVal.length > 1 && (
                      <Dropdown.Item onClick={handleSwitchGroup}>
                        Switch Group
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item onClick={handleSubscription}>
                      Create New Group
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleChangeGroupName}>
                      Change Group Name
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleChangePlan}>
                      Manage Group Plan
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        history.push(`/manage_users/${splitUrl[4]}`)
                      }
                    >
                      {userType === "AO" ||
                      userType === "AU" ||
                      userType === "AU + SU" ||
                      userType === "SU"
                        ? "All Users"
                        : "Manage Users"}
                    </Dropdown.Item>
                    <div
                      style={{
                        height: "1px",
                        width: "85%",
                        backgroundColor: "#e0e0e0", // Light color for the line
                        margin: "auto",
                      }}
                    ></div>
                    <Dropdown.Item onClick={handleProfile}>
                      My Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleInvites}>
                      My Invites
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleeventlog}>
                      Event Logs
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleRemSetting}>
                      Group Settings
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={handleLogout}>
                      Log off
                    </Dropdown.Item>{" "}
                  </>
                )}
                {shown1 && (
                  <>
                    {familyLengthVal.length > 1 && (
                      <Dropdown.Item onClick={handleSwitchGroup}>
                        Switch Group
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item onClick={handleSubscription}>
                      Create New Group
                    </Dropdown.Item>
                    <div
                      style={{
                        height: "1px",
                        width: "85%",
                        backgroundColor: "#e0e0e0", // Light color for the line
                        margin: "auto",
                      }}
                    ></div>
                    <Dropdown.Item onClick={handleProfile}>
                      My Profile
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        history.push(`/manage_users/${splitUrl[4]}`)
                      }
                    >
                      {userType === "AO" ||
                      userType === "AU" ||
                      userType === "AU + SU" ||
                      userType === "SU"
                        ? "All Users"
                        : "Manage Users"}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleInvites}>
                      My Invites
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleeventlog}>
                      Event Logs
                    </Dropdown.Item>
                    {userType !== "SU" && (
                      <Dropdown.Item onClick={handleRemSetting}>
                        Group Settings
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item href="#" onClick={handleLogout}>
                      Log off
                    </Dropdown.Item>
                  </>
                )}
                {shown2 && (
                  <>
                    <Dropdown.Item onClick={handleSubscription}>
                      Create New Group
                    </Dropdown.Item>
                    <div
                      style={{
                        height: "1px",
                        width: "85%",
                        backgroundColor: "#e0e0e0", // Light color for the line
                        margin: "auto",
                      }}
                    ></div>
                    <Dropdown.Item onClick={handleProfile}>
                      My Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleInvites}>
                      My Invites
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={handleLogout}>
                      Log off
                    </Dropdown.Item>
                  </>
                )}
                {shown3 && (
                  <>
                    {familyLengthVal.length > 1 && (
                      <Dropdown.Item onClick={handleSwitchGroup}>
                        Switch Group
                      </Dropdown.Item>
                    )}

                    <div
                      style={{
                        height: "1px",
                        width: "85%",
                        backgroundColor: "#e0e0e0", // Light color for the line
                        margin: "auto",
                      }}
                    ></div>
                    <Dropdown.Item onClick={handleInvites}>
                      My Invites
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        history.push(`/manage_users/${splitUrl[4]}`)
                      }
                    >
                      {userType === "AO" ||
                      userType === "AU" ||
                      userType === "AU + SU" ||
                      userType === "SU"
                        ? "All Users"
                        : "Manage Users"}
                    </Dropdown.Item>

                    <Dropdown.Item href="#" onClick={handleLogout}>
                      Log off
                    </Dropdown.Item>
                  </>
                )}

                {shown4 && (
                  <>
                    {familyLengthVal.length > 1 && (
                      <>
                        <Dropdown.Item onClick={handleSwitchGroup}>
                          Switch Group
                        </Dropdown.Item>
                        <div
                          style={{
                            height: "1px",
                            width: "85%",
                            backgroundColor: "#e0e0e0", // Light color for the line
                            margin: "auto",
                          }}
                        ></div>
                      </>
                    )}

                    <Dropdown.Item onClick={handleInvites}>
                      My Invites
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={handleLogout}>
                      Log off
                    </Dropdown.Item>
                  </>
                )}

                {shown5 && (
                  <>
                    <Dropdown.Item onClick={handleSubscription}>
                      Create New Group
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={handleLogout}>
                      Log off
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
            {showFamilyNav && (
              <Navbar.Offcanvas
                id="offcanvasNavbar-expand-xl"
                aria-labelledby="offcanvasNavbarLabel-expand-xl"
                className="order-last order-xl-first"
              >
                <Offcanvas.Header closeButton>
                  <Navbar.Brand href="/home">
                    <img src={Logo} alt="Eldery Life logo" />
                  </Navbar.Brand>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="align-items-xl-center flex-grow-1 77">
                    {showFamilyNav ? (
                      <>
                        {(userType === "AO + AU + SU" ||
                          userType === "AO + AU" ||
                          userType === "AU + SU" ||
                          userType === "AU" ||
                          parentUserUUId) && (
                          <>
                            <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isFamilyDashboardActive ||
                                  isSupportingDashboardActive
                                    ? "active"
                                    : ""
                                }`}
                                to={
                                  uuid
                                    ? !parentUserUUId
                                      ? `/dashboard/${splitUrl[4]}`
                                      : `/supporting_user_dashboard/${
                                          splitUrl[4]
                                        }/${
                                          parentUserUUId !== "undefined"
                                            ? parentUserUUId
                                            : splitUrl[5]
                                        }`
                                    : "#"
                                }
                              >
                                Dashboard
                              </Link>
                            </div>
                            <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isSubsActive ? "active" : ""
                                }`}
                                to={
                                  uuid
                                    ? !parentUserUUId
                                      ? `/myoutgoings/${uuid}`
                                      : `/user_myoutgoings/${uuid}/${
                                          parentUserUUId !== "undefined"
                                            ? parentUserUUId
                                            : splitUrl[5]
                                        }`
                                    : "#"
                                }
                              >
                                Outgoings
                              </Link>
                            </div>
                            <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isWarrantyActive ? "active" : ""
                                }`}
                                to={
                                  uuid
                                    ? !parentUserUUId
                                      ? `/warranties/${uuid}`
                                      : `/user_warranties/${uuid}/${
                                          parentUserUUId !== "undefined"
                                            ? parentUserUUId
                                            : splitUrl[5]
                                        }`
                                    : "#"
                                }
                              >
                                Warranties
                              </Link>
                            </div>
                            <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isGiftCardsActive ? "active" : ""
                                }`}
                                to={
                                  uuid
                                    ? !parentUserUUId
                                      ? `/vouchers_&_gift_cards/${uuid}`
                                      : `/user_vouchers_&_gift_cards/${uuid}/${
                                          parentUserUUId !== "undefined"
                                            ? parentUserUUId
                                            : splitUrl[5]
                                        }`
                                    : "#"
                                }
                              >
                                Vouchers & Gift cards
                              </Link>
                            </div>

                            <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isTasksActive ? "active" : ""
                                }`}
                                to={
                                  uuid
                                    ? !parentUserUUId
                                      ? `/todos/${uuid}`
                                      : `/user_todos/${uuid}/${
                                          parentUserUUId !== "undefined"
                                            ? parentUserUUId
                                            : splitUrl[5]
                                        }`
                                    : "#"
                                }
                              >
                                To-Dos
                              </Link>
                            </div>
                            <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isSavingsActive ? "active" : ""
                                }`}
                                to={
                                  !parentUserUUId
                                    ? `/savings/${splitUrl[4]}`
                                    : `/user_savings/${splitUrl[4]}/${
                                        parentUserUUId !== "undefined"
                                          ? parentUserUUId
                                          : splitUrl[5]
                                      }`
                                }
                              >
                                Life Accounts
                              </Link>
                            </div>

                            {/* <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isBenefitsActive ? "active" : ""
                                }`}
                                to={uuid ? `/discounts/${uuid}` : "#"}
                              >
                                Discounts
                              </Link>
                            </div> */}

                            <div className="nav-item">
                              <Link
                                className={`nav-link ${
                                  isCompareActive ? "active" : ""
                                }`}
                                to={uuid ? `/compare_and_save/${uuid}` : "#"}
                              >
                                Compare & save
                              </Link>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            )}
          </Container>

          {/* modal  */}
          <Modal
            show={showUpdateFmlyModal}
            onHide={() => setShowUpdateFmlyModal(!showUpdateFmlyModal)}
            className="choose_plan_modal"
          >
            <Modal.Header closeButton>
              {/* <Modal.Title><h3>Confirm Account plan</h3></Modal.Title>*/}
              <Modal.Title>
                <h3>Update Group Name</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form className="family-form" onSubmit={handleFamilyNameSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className={"mb-2"}>Group Name</Form.Label>
                  <Form.Control
                    className={
                      updateFmlyFormValues.family_name ? "invalid-input" : ""
                    }
                    type="text"
                    placeholder="Enter Group Name"
                    name="family_name"
                    id="family_name"
                    value={updateFmlyFormValues.family_name}
                    onChange={handleUpdateFmlyChange}
                  />

                  {Object.keys(updateFmlyFormErrors).length !== 0 &&
                  isUpdateFmlySubmit ? (
                    <p className="text-danger form-text">
                      {updateFmlyFormErrors.msg}{" "}
                    </p>
                  ) : (
                    ""
                  )}
                </Form.Group>
                <div className="text-center mt-5 d-flex align-items-center justify-content-center">
                  <Button className="" variant="primary" type="submit">
                    <i className="fa-solid fa-sm fa-add lh-1 align-middle me-2"></i>
                    Update Group Name
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </Navbar>
      </>
    );
  } else {
    return "";
  }
};

export default NavBar;
